import React from "react";

export default function If({ children, className, condition }) {
  if (condition) {
    return (
      <div className={className}>
        {children}
      </div>
    );
  }
  return null;
}
